import react from "react";
import styles from "./Banner.module.css";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import Image from "next/image";

function Banner(props) {
  const { subdomain, orgData, orgInfo, teachingInfo } = props;

  let orgIcon =
    subdomain == "stage"
      ? process.env.NEXT_PUBLIC_ORG_LOGO_ICON.replace("sub-domain", subdomain)
      : orgData?.officialIcon;
  // orgIcon = orgIcon.replace("sub-domain", subdomain);
  const formatNumber = (num) => {
    if (num === '' || isNaN(num)) return '';
    
    const number = parseInt(num);
    
    if (number >= 1000000) {
      // Format for millions
      const millions = number / 1000000;
      return `${milliers.toFixed(1)}M`.replace('.0', '');
    } else if (number >= 1000) {
      // Format for thousands
      const thousands = number / 1000;
      return `${thousands.toFixed(1)}K`.replace('.0', '');
    }
    
    return number.toString();
  };

  const backgroundStyle = teachingInfo?.bgImageUrl
  ? {
      backgroundImage: `url("${teachingInfo?.bgImageUrl}")`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }
  : {
      background: "linear-gradient(149deg, #004fe0 0%, #261e7d 40%, #2d69d8 100%)",
    };
  return (
    <div className={styles.Container}>
      <div className={styles.BannerContainer} style={{...backgroundStyle}}>
        <div className={styles.BannerContainerInner}>
        <div className={styles.BannerLogoMobile}>
            <img src={teachingInfo?.logoImageUrl} />
          </div>
          <div className={styles.BannerLft}>
            <h2>{teachingInfo?.name}</h2>
            <p> {teachingInfo?.shortDescription}</p>

            <div className={styles.StatusSection}>        
              <div className={styles.StatusSectionInner}>
                <div className={styles.StatusCard}>
                  <div className={styles.StatusNumber}>{orgInfo?.course_number_to_show}</div>
                  <div className={styles.StatusLabel}>Courses</div>
                </div>
                <div className={styles.StatusCardDivider}></div>

                <div className={styles.StatusCard}>
                  <div className={styles.StatusNumber}>{formatNumber(orgInfo?.student_number)}</div>
                  <div className={styles.StatusLabel}>Students</div>
                </div>
                {/* <div className={styles.StatusCardDivider}></div>
                <div className={styles.StatusCard}>
                  <div className={styles.StatusNumber}>2.2K</div>
                  <div className={styles.StatusLabel}>Reviews</div>
                </div> */}
              </div>
            </div>
            <div className={styles.MoreLink}><a onClick={() => document.getElementById("about")?.scrollIntoView({ behavior: "smooth" })}>About {teachingInfo?.name} <ArrowDownwardIcon /></a></div>

          </div>

          <div className={styles.BannerLogo}>
            <img src={teachingInfo?.logoImageUrl} />

          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
